import { IReport6Applicant } from "../../../model/report/Report6Applicant";
import Report6ReportingPeriodPresentationModel, {
  TReport6ReportingPeriodPresentationModel
} from "./Report6ReportingPeriodPresentationModel";
import { IReport6ReportingPeriod } from "../../../model/report/Report6ReportingPeriod";

export interface TReport6ApplicantPresentationModel {
  id: number;
  partyId: number;
  name: string;
  lastName: string;
  reportingPeriods: TReport6ReportingPeriodPresentationModel[];
  fullName: string;
}

const Report6ApplicantPresentationModel = (
  data: IReport6Applicant
): TReport6ApplicantPresentationModel => {
  return {
    ...data,
    reportingPeriods: data.reportingPeriods.map(
      (reportingPeriod: IReport6ReportingPeriod) => {
        return Report6ReportingPeriodPresentationModel(reportingPeriod);
      }
    )
  };
};

export default Report6ApplicantPresentationModel;
